module.exports = __webpack_public_path__ + "img/shield.ef7c7a4d.svg";